/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { VisuallyHidden, typography2 } from '@coursera/cds-core';

import type { Props as ChatMessageProps } from 'bundles/ai-coach-platform/components/patterns/chat/common/messages/ChatMessage';
import ChatMessageBody from 'bundles/ai-coach-platform/components/patterns/chat/common/messages/ChatMessageBody';

const styles = {
  learnerMessageBody: css`
    background: linear-gradient(279deg, #24dbe7 -5.78%, #6923de 12%);
    background-clip: text;
    color: transparent;
    display: inline-block;
    padding: var(--cds-spacing-100) var(--cds-spacing-100) 0 var(--cds-spacing-100);

    p {
      font: ${typography2.titleXSmall.font} !important;
      margin-bottom: 0;
    }

    p + p {
      margin-top: var(--cds-spacing-100);
    }
  `,
};

/**
 * Renders the first Coach message inside a welcome-styled card that mirrors ChatZeroState's
 * visual treatment (gradient title, flat layout). Used in the two-panel XDP Coach for
 * logged-in learners so the welcome reads consistently whether the LLM has responded or not.
 */
const FirstLearnerMessage = ({ message, learnerPersona, children, searchTerm }: ChatMessageProps) => {
  return (
    <>
      <VisuallyHidden>{learnerPersona.name}</VisuallyHidden>

      <ChatMessageBody message={message} searchTerm={searchTerm} css={styles.learnerMessageBody}>
        {children}
      </ChatMessageBody>
    </>
  );
};

export default FirstLearnerMessage;
